import ProjectService from '../../project.service.js';
import Service from '@/service/index.js';
export default {
  components: {
  },
  data() {
    return {
      purchaseId: '',
      // contractFile: {
      //   docUrl: '',
      //   docUrl1: '',
      //   docUrl2: '',
      //   docUrl3: '',
      //   docUrl4: '',
      //   docUrl5: '',
      //   docUrl6: ''
      // }
      contractFile: [
        {code: 3, value: '竞买须知'},
        {code: 4, value: '受让方申请书'},
        {code: 5, value: '受理通知书'},
        {code: 6, value: '受理通知书'},
        {code: 7, value: '成交确认书'},
        {code: 9, value: '产权交易合同'},
        {code: 12, value: '产权交易鉴证书'},
        {code: 13, value: '产权交易见证书'},
        {code: 14, value: '产权交易合同(林地林木)'},
        {code: 15, value: '产权交易合同(农户承包地)'},
        {code: 16, value: '产权交易合同(水面)'}
      ],
      file: [],
      id: '',
      projectCode: '',
      fileList: []
    };
  },
  created() {
    Service.getSelectList('TRANSFER_CONTRACT_TYPE').then(res => {
      // console.log(res.data);
      this.fileList = res.data;
    });
    this.id = this.$route.query.id;
    this.projectCode = this.$route.query.projectCode;
    console.log(this.$route.query.id);
  },
  mounted() {
    this.getProjectFile();
  },
  methods: {
    // 获取项目文件的接口
    getProjectFile () {
      ProjectService.projectFileDownload(this.id).then(res => {
        if (res && res.code === '0' && res.data) {
          this.file = res.data.map(item => {
            return {
              url: item.url,
              value: item.contractName,
              type: item.contractType,
              name: item.userName
            };
          });
          // this.file = res.data.map(item => {
          //   return {
          //     ...item,
          //     value: this.contractFile.find(child => Number(child.code) === Number(item.contractType)).value
          //   };
          // });
          console.log(this.file, 'res.data');
        }
      });
    },
    openWindow (key) {
      window.open(key);
    }
  }
};
